import React from "react";
import { formataDataHora } from "../../utils/formatadorData";
import "./PainelDisponibilidade.css";

export const PainelDisponibilidadeCard = ({ situacao }) => {
  const semDados = situacao.codigoResposta === null || situacao.codigoResposta === undefined;
  const disponivel = !semDados && situacao.codigoResposta >= 200 && situacao.codigoResposta < 300;

  return (
    <div className="painel-disponibilidade-card">
      <div className="painel-disponibilidade-card__conteudo">
        <h3 className="painel-disponibilidade-card__titulo">
          {situacao.nomeApi} - {situacao.nomeOrgaoOperador}
        </h3>
        <div className="painel-disponibilidade-card__timestamp">
          <i className="far fa-clock" aria-hidden="true"></i>
          <span>{semDados ? "Sem dados na última hora" : formataDataHora(new Date(situacao.dataHoraResposta))}</span>
        </div>
      </div>
      <div
        className={`painel-disponibilidade-card__status ${semDados ? "painel-disponibilidade-card__status--sem-dados" : disponivel ? "painel-disponibilidade-card__status--disponivel" : "painel-disponibilidade-card__status--indisponivel"}`}
        title={semDados ? "Sem dados recentes" : disponivel ? "Disponivel" : "Indisponivel"}
      >
        <i className={`fas ${semDados ? "fa-question" : disponivel ? "fa-check" : "fa-times"}`} aria-hidden="true"></i>
      </div>
    </div>
  );
};
